import * as React from "react";
import {routeConfig} from "../../../../config/language/ja-JP/presentation/route_text";
import {CustomerBlackList} from "../../../../domain/model/customer_black_list";
import PageWrapper from "../../../common/atom/wrapper/page_wrapper";
import Breadcrumbs from "../../../common/molecular/breadcrumbs/breadcrumbs";
import {TBreadcrumbItem} from "../../../type/common";
import CustomerBlackListAddForm from "./edit/client_black_list_add_form";
import CustomerBlackListDeleteForm from "./edit/client_black_list_delete_form";
import Faq from "../../faq";

interface IProps {
    isLoading: boolean;
    customerBlackList: CustomerBlackList | null;
    handleAddCustomerBlackListSubmit: (values: any) => void;
    handleDeleteCustomerBlackListSubmit: (
        event: React.MouseEvent<HTMLButtonElement>
    ) => void;
}

const CustomerBlackListEditComponent: React.FC<IProps> = (props) => {
    const {
        customerBlackList,
        handleDeleteCustomerBlackListSubmit,
        handleAddCustomerBlackListSubmit,
    } = props;

    const breadcrumbItems: TBreadcrumbItem[] = [
        routeConfig.customerRoot,
        routeConfig.customerMypage,
        routeConfig.customerBlackList,
    ];

    return (
        <React.Fragment>
            <PageWrapper>
                <div style={{maxWidth: 600, margin: "0 auto"}}>
                    <Breadcrumbs breadcrumbItems={breadcrumbItems}/>
                    {/*<PageTopInfo*/}
                    {/*  information={pageTopInfoConfig.customerClientBlock}*/}
                    {/*  linkURL={OuterURL.customerClientBlockFaqURL}*/}
                    {/*/>*/}
                    <Faq title={"企業ブロック"}
                         text={"企業ブロック機能は、特定の企業からのプロフィール閲覧を防ぐ機能です。利用するには、ブロックしたい企業のメールアドレスのドメイン部分（例：libera-inc.com）を登録します。"}
                         link={
                             "https://branch-saturn-9ef.notion.site/178b91fe393e80e0a5c5c196cf2fab60"
                         }/>
                    <CustomerBlackListAddForm
                        onSubmit={handleAddCustomerBlackListSubmit}
                    />
                    <CustomerBlackListDeleteForm
                        customerBlackList={customerBlackList}
                        handleDeleteCustomerBlackListSubmit={
                            handleDeleteCustomerBlackListSubmit
                        }
                    />
                </div>
            </PageWrapper>
        </React.Fragment>
    );
};

export default CustomerBlackListEditComponent;



// WEBPACK FOOTER //
// ./src/presentation/component/customer/black_list/customer_black_list_edit.tsx